import React from "react"
import { Col, Row } from "reactstrap"

const ButtonStack = ({
  bgUrl,
  thumbnailUrl,
  name,
  textColor,
  menuItems,
  font,
  menuColor,
}) => {
  const items = menuItems.slice(0, 6).map(item => (
    <Row
      key={item?.id}
      style={{
        color: textColor,
        fontFamily: font,
        fontSize: "1em",
        padding: "5px",
        width: "85%",
        height: "35px",
        borderRadius: "3px",
        backgroundColor: menuColor,
        marginTop: "7px",
      }}
    >
      <Col xs="auto">
        <div
          style={{
            backgroundImage: `url("${item?.icon?.url}")`,
            width: "18px",
            height: "18px",
            backgroundSize: "cover",
          }}
        />
      </Col>
      <Col>
        <span>{item?.label}</span>
      </Col>
    </Row>
  ))
  return (
    <div
      style={{
        backgroundImage: bgUrl,
        width: "105%",
        height: "105%",
        backgroundSize: "cover",
        marginLeft: "-5px",
        backgroundPosition: "center center",
        boxShadow: "inset 0 0 0 500px rgb(0 0 0 / 40%)",
      }}
    >
      <p
        style={{
          fontSize: "20px",
          textAlign: "center",
          paddingBlockStart: "1em",
          color: textColor,
        }}
      >
        {name}
      </p>
      <div
        style={{
          width: "100%",
          height: "30%",
          backgroundImage: thumbnailUrl,
          position: "relative",
          backgroundSize: "cover",
          backgroundPosition: "center center",
        }}
      ></div>
      <div
        style={{
          paddingTop: "5px",
          flexWrap: "wrap",
          flexDirection: "column",
          justifyContent: "center",
          display: "flex",
          alignContent: "center",
        }}
      >
        {items}
      </div>
    </div>
  )
}

export default ButtonStack
